export const dynamic = 'force-dynamic'
import React from 'react'

import { Metadata } from 'next';

import ProductPage from '@/components/Products/ProductPage';
export const metadata: Metadata = {
  title: 'Products | TEX EXCELLENCE LIMITED',
  description: 'Products | TEX EXCELLENCE LIMITED',
}

export default function ProductPageRoute() {

  return (
    <>
      <ProductPage />
    </>
  )
}

// export default ProductPageRoute
